
import { CensusFormProvider } from '../../census/components/provider/CensusFormProvider';
import OfcEditTabs from './OfcEditTabs';

export default function OfcEditPage({ fromPark }: { fromPark?: boolean }) {
  return (
    <CensusFormProvider speciesFilter="ofc">
      <OfcEditTabs fromPark={fromPark} />
    </CensusFormProvider>
  );
}